import { SxProps, Theme } from '@mui/material/styles';
import classNames from 'classnames';
import { ElementType, FC, ReactNode } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { ListItemState } from '../../context/ListContext';
import { ListProvider } from '../../context/ListProvider';
import { Spacing } from '../../theme/type';
import { getMargin, getPadding } from '../../utils/spacing';
import { StyledBox } from './styled';

type ListProps = {
  children?: ReactNode;
  itemProps?: ListItemState;
  margin?: Spacing;
  padding?: Spacing;
  sx?: SxProps<Theme>;
} & (
  | { bullets: true; numbers?: false }
  | { bullets?: false; numbers: true }
  | { bullets?: false; numbers?: false }
);

const List: FC<ListProps> = ({
  bullets = false,
  children,
  itemProps,
  margin,
  numbers = false,
  padding,
  sx,
}) => {
  const sxList = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      ...sx,
      ...(getMargin(margin, '0') as SxProps<Theme>),
      ...(getPadding(padding) as SxProps<Theme>),
    }),
    [sx, margin, padding]
  );

  const component: ElementType = numbers ? 'ol' : 'ul';
  const className = classNames({ bullets: bullets || numbers });

  return (
    <ListProvider value={itemProps}>
      <StyledBox className={className} component={component} sx={sxList}>
        {children}
      </StyledBox>
    </ListProvider>
  );
};

export default List;
